import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Round } from '../../../objects/round';
import { PlayerService } from '../../../services/player.service';
import { Player } from '../../../objects/player';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PostScoreDialogComponent } from '../post-score-dialog/post-score-dialog.component';
import { Router } from '../../../../../node_modules/@angular/router';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 's18-handicap-rounds',
  templateUrl: './handicap-rounds.component.html',
  styleUrls: ['./handicap-rounds.component.scss']
})
export class HandicapRoundsComponent implements OnInit {
  @Input() player: Player;
  @Input() canPost: boolean;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  @Output() postRoundsUpdated = new EventEmitter<string>();

  tournamentRounds: Round[];
  handicap_rounds: Round[];
  last_25: Round[];
  handicap_history: any[];
  projectedIndex: number = 0;
  posting: boolean = false;
  playerIndex: any;

  constructor(
    private playerService: PlayerService,
    private eventService: EventService,
    private dialog: MatDialog,
    private router: Router,
    private snackbar: MatSnackBar
  ) { }

  ngOnInit() {
    if (this.player) {
      this.fetchRounds();
    }
  }


  fetchRounds() {
    //this.getTournamentRounds();
    this.getRevisionRounds();
    this.getHandicapHistory();
    this.getLast25Rounds();
    this.playerService.getGolferHandicapIndex(this.player.player_id.toString())
      .subscribe(resp => {
        this.playerIndex = JSON.parse(resp.d);
        console.log(this.playerIndex)
      })
  }

  getTournamentRounds() {
    this.playerService.getAllTournamentRounds(this.player.player_id.toString())
      .subscribe(resp => {
        this.tournamentRounds = JSON.parse(resp.d).result;
      });
  }



  postRoundsToUsga() {
    this.posting = true;
    this.playerService.syncRounds(this.player.player_id)
      .subscribe(resp => {
        this.posting = false;
        this.fetchRounds();
      }, err => {
        console.log(err);
      });
    this.checkStatus(this.player.player_id.toString());
  }

  showSnackbar(player_id, text) {
    if (this.posting) {
      if (text === '') {
        text = "Synchronizing rounds, this could take a minute ...";
      }
      var snackbarRef = this.snackbar.open(text, null, { duration: 2000 });
      snackbarRef.afterDismissed()
        .subscribe(() => {
          this.checkStatus(player_id);
        });
    }
  }

  checkStatus(player_id) {
    this.eventService.getProcessStatus(player_id)
      .subscribe(resp => {
        var status = JSON.parse(resp.d).status;
        this.showSnackbar(player_id, status);
      });
  }

  showHandicapPlusInfo() {
    var message = "If you currently have a GHIN or a Handicap Id and are an active member of a club, you can change the Handicap Id in your profile to that number.  However, if you want updated stats and hole-by-hole scoring, you should subscribe to one of our clubs through our Handicap+ subscription.";
    let ref = this.snackbar.open(message, "Search Clubs", { panelClass: 'warning-toast', duration: 20000, verticalPosition: 'top', horizontalPosition: 'center' });
    ref.onAction().subscribe(() => {
      this.router.navigateByUrl("clubs/search");
    });
  }

  showUpgradeInfo() {
    var message = "Upgrade to one of our clubs inclubed in the Handicap+ subscription and get enhanced stats, hole-by-hole scoring and much more.";
    let ref = this.snackbar.open(message, "Search Clubs", { panelClass: 'warning-toast', duration: 20000, verticalPosition: 'top', horizontalPosition: 'center' });
    ref.onAction().subscribe(() => {
      this.router.navigateByUrl("clubs/search");
    });
  }

  getRevisionRounds() {
    this.playerService.getRevisionRounds(this.player.player_id.toString())
      .subscribe(resp => {
        console.log("rev")
        this.handicap_rounds = JSON.parse(resp.d).scores;
        console.log(this.handicap_rounds);
      });
  }

  getHandicapHistory() {
    this.playerService.getHandicapHistory(this.player.player_id.toString())
      .subscribe(resp => {
        console.log("hcp");
        console.log(JSON.parse(resp.d));
        this.handicap_history = JSON.parse(resp.d).handicapHistory.handicap_revisions;
      });
  }

  getLast25Rounds() {
    this.playerService.getLast25Rounds(this.player.player_id.toString())
      .subscribe(resp => {
        this.last_25 = JSON.parse(resp.d).result;
      });
  }

  calculateProjectedIndex() {
    var last_20_index = [];
    for (var j = 0; j < 20; j++) {
      last_20_index.push(this.last_25[j].round_hcp);
    }
    last_20_index.sort((a, b) => { return a - b });
    this.projectedIndex = 0;
    for (var i = 0; i < 10; i++) {
      this.projectedIndex += last_20_index[i];
    }
    this.projectedIndex = this.projectedIndex / 10 * 0.96;
  }

  showPostDialog(holeByHole) {
    var dialogRef = this.dialog.open(PostScoreDialogComponent, {
      width: '400px',
      data: {
        player_id: this.player.player_id,
        holeByHole: holeByHole
      }
    });

    dialogRef.afterClosed()
      .subscribe(resp => {
        if (resp === 'success') {
          this.getLast25Rounds();
          this.tabGroup.selectedIndex = 2;
        }
        console.log(resp);
      })
  }

  share() {
    this.router.navigateByUrl('/player-lookup/' + this.player.player_id);
  }


}
